import {createApi} from '@reduxjs/toolkit/query/react';
import {axiosBaseQuery, REFETCH_POLICY} from 'src/axiosBaseQuery';
import {
    BasePriceDTO,
    CreatePriceRequest,
    PagePriceItemDTO,
    PriceDTO,
    SearchPriceItemRequest,
    UpdatePriceRequest,
} from 'src/types';
import {getBaseURL} from 'src/utils/helper';

export const pricingApi = createApi({
    reducerPath: 'pricingApi',
    ...REFETCH_POLICY,
    baseQuery: axiosBaseQuery({
        baseUrl: String(getBaseURL() + '/prices'),
    }),
    tagTypes: ['Prices', 'Price', 'PriceItems'],
    endpoints: (build) => ({
        createPrice: build.mutation<PriceDTO, CreatePriceRequest>({
            query: (data) => ({url: '', method: 'post', data}),
            invalidatesTags: ['Prices'],
        }),
        updatePrice: build.mutation<PriceDTO, { priceId: number; data: UpdatePriceRequest }>({
            query: ({priceId, data}) => ({url: `/${priceId}`, method: 'put', data}),
            invalidatesTags: (_result, _error, arg) => [
                {type: 'Price' as const, id: arg.priceId},
                {type: 'Prices' as const, id: 'LIST'},
                'PriceItems',
            ],
        }),
        getPriceById: build.query<BasePriceDTO, number>({
            query: (priceId) => ({url: `/${priceId}`, method: 'get'}),
            providesTags: (_result, _error, priceId) => [{type: 'Price' as const, id: priceId}],
        }),
        findPriceItemsByFilters: build.query<PagePriceItemDTO, SearchPriceItemRequest>({
            query: ({data, params}) => ({
                url: '/priceItems/search',
                method: 'post',
                data,
                params,
            }),
            providesTags: (result) => {
                if (result?.content) {
                    return [
                        {type: 'PriceItems' as const, id: 'LIST'},
                        ...result.content.map((item) => ({
                            type: 'PriceItems' as const,
                            id: item?.id,
                        })),
                    ];
                }
                return [{type: 'PriceItems' as const, id: 'LIST'}, 'PriceItems' as const];
            },
        }),
    }),
});